import { createFileRoute } from "@tanstack/react-router";
import { CsvBankLanderPage } from "@/pages/tools/csv-bank-lander";
import { head, loader } from "@/pages/tools/csv-bank-lander.meta";

export const Route = createFileRoute("/$locale/tools/csv-to-beancount/$bank")({
  loader,
  head,
  // The slug comes from the loader, which has already validated it against
  // the preset registry — the component never sees an unknown bank.
  component: function CsvBankRoute() {
    const { slug } = Route.useLoaderData();
    return <CsvBankLanderPage slug={slug} />;
  },
});
